(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/components/navigation.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/components/navigation.js');
"use strict";


const {
  useCallback
} = React;
const Navigation = _ref => {
  let {
    productSettings,
    activeKey,
    onSelect
  } = _ref;
  const onClick = useCallback(event => {
    event.preventDefault();
    const key = event.currentTarget.getAttribute('data-id');
    onSelect(key);
  }, [onSelect]);
  return React.createElement("nav", {
    "aria-labelledby": "navigation-heading",
    className: "panel panel-default"
  }, React.createElement("div", {
    className: "panel-heading"
  }, React.createElement("h2", {
    id: "navigation-heading"
  }, React.createElement("strong", null, "Spelprodukt"))), React.createElement("ul", {
    className: "list-group"
  }, Object.keys(productSettings).map(key => {
    const setting = productSettings[key];
    const isActive = key === activeKey;
    return React.createElement("li", {
      key: key
    }, React.createElement("a", {
      className: "fc-navy list-group-item f-capitalize tt-product-link js-product-link".concat(isActive ? ' tt-product-link-selected' : ''),
      "data-id": key,
      href: "#".concat(setting.urlName),
      id: setting.urlName,
      onClick: onClick
    }, setting.productName));
  })));
};
setGlobal('svs.tt.components.Navigation', Navigation);

 })(window);